<div class="container-fluid">
  <div class="card-panel mt-5" *ngIf="entidade">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header-light page-title="PAGAMENTOS" fa-icon="cash-register"></lib-page-header-light>
      </div>
      <div class="col-md-4">
        <a [routerLink]="['/contratos', entidade.id, 'editar']"
          class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/padrao/cross.png" alt="cvs" title="Sair" height="20" width="20">
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label style="font-weight: bold; color: #757575">
          {{login.orgao.codigo}} {{login.orgao.nome}}
        </label>
      </div>
    </div>
    <hr class="mt-0 mb-4" />
    <div class="row pb-0">
      <label class="col-sm-1 col-form-label">Número:</label>
      <div class="col-md-3 pb-0">
        <span class="form-control form-control-plaintext font-weight-bold">{{entidade.numero}}</span>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-1 col-form-label">Favorecido:</label>
      <div class="col-md-11">
        <span class="form-control form-control-plaintext font-weight-bold">{{entidade.favorecido.cpf_cnpj | CPF}} {{entidade.favorecido.nome}}</span>
      </div>
    </div>
    <div class="row pb-5 pt-5" *ngIf="listaPagamentos && !listaPagamentos.length">
      <div class="col-12">
        <span class="font-weight-bold">Não há pagamentos efetuados para o contrato!</span>
      </div>
    </div>
    <div class="row" *ngIf="listaPagamentos && listaPagamentos.length > 0">
      <div class="col-12 table-responsive">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col" class="text-center">Número</th>
              <th scope="col" class="text-center">Parcela</th>
              <th scope="col" class="text-center">Data liquidação</th>
              <th scope="col" class="text-center">Data pagamento</th>
              <th scope="col">Conta bancária</th>
              <th scope="col" class="text-right">Valor pago</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaPagamentos">
              <th scope="row" class="text-center">{{("00000" + item.liquidacao.empenho.numero).slice(-5) }}</th>
              <th scope="row" class="text-center">{{item.liquidacao.parcela}}</th>
              <td class="text-center">{{item.liquidacao.data_liquidacao | date:'dd/MM/yyyy':'GMT'}}</td>
              <td class="text-center">{{item.data_pagamento | date:'dd/MM/yyyy':'GMT'}}</td>
              <td>{{item.conta.agencia}} {{item.conta.numero_conta}} - {{item.conta.banco.nome}}</td>
              <td class="text-right">{{item.valor_pago | number:'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
